import React, { useState } from 'react';
import Card from 'olive-react-myoneui/lib/Card';
import Dropdown from 'olive-react-myoneui/lib/Dropdown';

import { documentIcon, dots3VerticalIcon, folderIcon, StarBlankIcon, StarIcon ,shareOIcon} from '../../../constants/icons';

const DocFileFolderBlock = ({item,onDropdownClick, className, starred, toggleBookMark, handleOffcanvas, handleDropdownClick }) => {
    const setFavorite = async (item) => {
        let data = {
            item_id: starred ? item.ib_item_id :item.id,
            starred_detail: starred ? true : item.starred_detail && item.starred_detail == 1 ? true : false
        }
        await toggleBookMark(data);
    };
    const showDetails = async (itemId,eventKey) => {
        let data = {
            itemId: itemId,
            eventKey: eventKey
        }
        await handleOffcanvas(data);
    } 
    const dropDownClickAction = async (itemId, itemType, parentId, ditem, itemName,itemOriginalFilename, itemDocumentType, itemDocumentTags='', itemSectionType='', itemFolderShortDescription='', itemDownloadUrl='',itemAccessType='',itemSharePermission='' ) => {
        ditem.itemId                        = itemId;
        ditem.itemType                      = itemType;
        ditem.parentId                      = parentId;
        ditem.itemName                      = itemName;
        ditem.itemOriginalFilename          = itemOriginalFilename;
        ditem.itemDocumentType              = itemDocumentType;
        ditem.itemDocumentTags              = itemDocumentTags;
        ditem.itemSectionType               = itemSectionType;
        ditem.itemFolderShortDescription    = itemFolderShortDescription;
        ditem.itemDownloadUrl               = itemDownloadUrl;
        ditem.itemAccessType                = itemAccessType;
        ditem.itemSharePermission           = itemSharePermission
        
        await handleDropdownClick(ditem);
    }
    return (
        <Card className={`${className || ''} myk__stu-dms-folder border-0`}>
            {starred ? 
            
            <Card.Body className="myk__stu-dms_folder-inner">
                {item.ib_item_type === '0' ? (
                    <div className="myk__stu-dms_folder-icon">{folderIcon}</div>
                ) : (
                    <div className="myk__stu-dms_folder-icon myk__stu-dms_docu-icon">{documentIcon}</div>
                )}
                
                <div className="myk__stu-fol_content-wrapper">
                    <h2>{item.ib_item_name}</h2>
                    {/* need to convert created date to formatAMPM(changeDatesFormat(convertUTCtoLocalTime(singleFolderData['shared_by']['created_date']))); pattern  */}
                    <p>{item.updated_date}</p> 
                </div>

                <div className="mk__stu-dms-fol_action" onClick={(event) => onDropdownClick(event)}>
                    <div className="favroite-doc" onClick={() => setFavorite(item)}>
                        {StarIcon}
                    </div>
                    <Dropdown className="dots-dropdown dropdown-select text-end" align="end" onClick={(event) => onDropdownClick(event)}> 
                        <Dropdown.Toggle as="div" role="button" tabIndex={0} className="btn btn-icon border-0 rounded-circle">
                            {dots3VerticalIcon}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu mw-dropdown-default">
                            {item.dropdownItems.map((ditem, index) => (
                                <React.Fragment key={index}>
                                    <Dropdown.Item eventKey={ditem.key} onClick={() => dropDownClickAction(item.ib_item_id, item.ib_item_type, item.ib_item_parent_id, ditem,item.ib_item_name, item.ib_document_file_name, item.ib_item_category)} className={ditem.label === 'More Info' ? 'view-more-items' : ''}>
                                        {ditem.icon} {ditem.label}
                                    </Dropdown.Item>
                                    {ditem.subItems && ditem.subItems.length > 0 && (
                                        <div className="myk__stu-more-items dropdown-second-level dropdown-menu">
                                            {ditem.subItems.map((subItem, subIndex) => (
                                                <Dropdown.Item key={subIndex} eventKey={subItem.key} onClick={() => showDetails(item.ib_item_id, subItem.eventKey)}>
                                                    {subItem.icon} {subItem.label}
                                                </Dropdown.Item>
                                            ))}
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Card.Body>
            
            :
            <Card.Body className="myk__stu-dms_folder-inner">
                {item.i_item_type === '0' ? (
                    <div className="myk__stu-dms_folder-icon">{folderIcon}</div>
                ) : (
                    <div className="myk__stu-dms_folder-icon myk__stu-dms_docu-icon">{documentIcon}</div>
                )}
                
                <div className="myk__stu-fol_content-wrapper">
                    <h2>{item.i_item_name}</h2>
                    {/* need to convert created date to formatAMPM(changeDatesFormat(convertUTCtoLocalTime(singleFolderData['shared_by']['created_date']))); pattern  */}
                    <p>{item.shared_by ? item.shared_by.created_date : item.updated_date}</p> 
                </div>

                <div className="mk__stu-dms-fol_action" onClick={(event) => onDropdownClick(event)}>
                    <div className="favroite-doc" onClick={() => setFavorite(item)}>
                        {item.starred_detail === "1" ? StarIcon : StarBlankIcon}
                    </div>
                    {item.share_permission === "1" &&
                        <div className="favroite-doc" style={item.shared_detail === "1" ? { color: "blue" } : {}} onClick={() => dropDownClickAction(item.id, item.i_item_type, item.i_parent_id, {key:"2"}, item.i_item_name, item.i_orginal_filename, item.i_document_type, item.i_document_tags, item.i_section_id, item.i_folder_short_desc, item.download_url, item.access_type,item.share_permission)}>
                            {shareOIcon}
                        </div>
                    }
                    <Dropdown className="dots-dropdown dropdown-select text-end" align="end" onClick={(event) => onDropdownClick(event)}> 
                        <Dropdown.Toggle as="div" role="button" tabIndex={0} className="btn btn-icon border-0 rounded-circle">
                            {dots3VerticalIcon}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu mw-dropdown-default">
                            {item.dropdownItems.map((ditem, index) => (
                                <React.Fragment key={index}>
                                    <Dropdown.Item eventKey={ditem.key} onClick={() => dropDownClickAction(item.id, item.i_item_type, item.i_parent_id, ditem, item.i_item_name, item.i_orginal_filename, item.i_document_type, item.i_document_tags, item.i_section_id, item.i_folder_short_desc, item.download_url, item.access_type,item.share_permission)} className={ditem.label === 'More Info' ? 'view-more-items' : ''}>
                                        {ditem.icon} {ditem.label}
                                    </Dropdown.Item>
                                    {ditem.subItems && ditem.subItems.length > 0 && (
                                        <div className="myk__stu-more-items dropdown-second-level dropdown-menu">
                                            {ditem.subItems.map((subItem, subIndex) => (
                                                <Dropdown.Item key={subIndex} eventKey={subItem.key} onClick={() => showDetails(item.id,subItem.eventKey)}>
                                                    {subItem.icon} {subItem.label}
                                                </Dropdown.Item>
                                            ))}
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Card.Body>
            }
        </Card>
    );
};

export default DocFileFolderBlock;
